import { render, staticRenderFns } from "./extractcode.vue?vue&type=template&id=0a4d202a&scoped=true&"
import script from "./extractcode.vue?vue&type=script&lang=js&"
export * from "./extractcode.vue?vue&type=script&lang=js&"
import style0 from "./extractcode.vue?vue&type=style&index=0&id=0a4d202a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4d202a",
  null
  
)

export default component.exports